import { useHttp } from '../http'

export const useClubEventHttp = () => {

    const find = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().get(`club-events/${id}`, payload)
    }

    const create = <T>(payload: any): Promise<T> => {
        return useHttp().post(`club-events`, payload)
    }

    const update = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().put(`club-events/${id}`, payload)
    }

    const get = <T>(payload: any): Promise<T> => {
        return useHttp().get(`club-events`, payload)
    }

    const del = <T>(id: number): Promise<T> => {
        return useHttp().del(`club-events/${id}`)
    }

    const photo = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().post(`club-events/${id}/photo`, payload)
    }

    return {
        find,
        create,
        update,
        get,
        del,
        photo
    }
}
